var _rect, _g, _path, _path2, _rect2, _rect3, _rect4, _rect5, _path3, _path4, _path5, _path6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVipSyncLimitation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 69,
    viewBox: "0 0 65 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 4,
    width: 56,
    height: 56,
    rx: 28,
    fill: "url(#paint0_radial_4149_98958)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter0_f_4149_98958)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.963 54.4795H49.037L52 53.0906H12L14.963 54.4795Z",
    fill: "#1A1B1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7405 60.0347L31.9992 62.8125L51.259 60.0347H12.7405Z",
    fill: "#1A1B1D"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.44445,
    height: 3.7037,
    transform: "matrix(1 0 0 -1 34.2219 59.1084)",
    fill: "#1A1B1D"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.44444,
    height: 3.7037,
    transform: "matrix(1 0 0 -1 16.4446 59.1084)",
    fill: "#1A1B1D"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.44445,
    height: 3.7037,
    transform: "matrix(1 0 0 -1 43.1111 59.1084)",
    fill: "#1A1B1D"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.44445,
    height: 3.7037,
    transform: "matrix(1 0 0 -1 25.3342 59.1084)",
    fill: "#1A1B1D"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.463 41.667H49.537L52.5 46.1114H12.5L15.463 41.667Z",
    fill: "#1A1B1D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2405 23.8889L32.4992 15L51.759 23.8889H13.2405Z",
    fill: "#1A1B1D"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 34.7219,
    y: 26.8506,
    width: 4.44445,
    height: 11.8519,
    fill: "#1A1B1D"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 16.9446,
    y: 26.8506,
    width: 4.44444,
    height: 11.8519,
    fill: "#1A1B1D"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 43.6111,
    y: 26.8506,
    width: 4.44445,
    height: 11.8518,
    fill: "#1A1B1D"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 25.8342,
    y: 26.8506,
    width: 4.44445,
    height: 11.8519,
    fill: "#1A1B1D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64 32C64 49.397 49.897 63.5 32.5 63.5C15.103 63.5 1 49.397 1 32C1 14.603 15.103 0.5 32.5 0.5C49.897 0.5 64 14.603 64 32Z",
    stroke: "white",
    strokeOpacity: 0.1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50 6C50.8324 8.3322 52.6678 10.1676 55 11C52.6678 11.8324 50.8324 13.6678 50 16C49.1676 13.6678 47.3322 11.8324 45 11C47.3322 10.1676 49.1676 8.3322 50 6Z",
    fill: "#1A1B1D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M57.0357 3C57.5411 4.41598 58.6555 5.53031 60.0714 6.03571C58.6555 6.54112 57.5411 7.65545 57.0357 9.07143C56.5303 7.65545 55.416 6.54112 54 6.03571C55.416 5.53031 56.5303 4.41598 57.0357 3Z",
    fill: "#1A1B1D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4634 11.5C59.9689 12.916 61.0832 14.0303 62.4992 14.5357C61.0832 15.0411 59.9689 16.1555 59.4634 17.5714C58.958 16.1555 57.8437 15.0411 56.4277 14.5357C57.8437 14.0303 58.958 12.916 59.4634 11.5Z",
    fill: "#1A1B1D"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_4149_98958",
    x: 2,
    y: 44,
    width: 60,
    height: 27,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_4149_98958"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_4149_98958",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(32.5 32) rotate(90) scale(28)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.526042,
    stopColor: "white",
    stopOpacity: 0.29
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVipSyncLimitation);
export default __webpack_public_path__ + "static/media/vip-sync-limitation.bd5bbffbed5805db7e1e39897d3ccb2f.svg";
export { ForwardRef as ReactComponent };